<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
  class="dark bg-gray-900 print:hidden"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="navigation.default"
  [opened]="!isScreenSmall"
>
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <!-- Logo -->
    <div class="flex items-center h-20 p-6 pb-0 mb-5">
                  <!-- Light version -->
                  <img
                      class="dark:hidden w-30"
                      src='../../../../../assets/images/logo/logo-text-old.svg'
                      alt="Logo image">
                  <!-- Dark version -->
                  <img
                      class="hidden dark:flex w-50"
                      src="assets/images/logo/logo-text-on-dark_new.svg"
                      alt="Logo image">
    </div>
    <div class="flex md:hidden items-center gap-3 px-6 mb-5">
      <a
        class="flex h-11 flex-1 items-center justify-center rounded-xl text-gray-300 transition hover:text-primary"
        [routerLink]="['/account/affiliate-program']"
        aria-label="Реферальная программа"
      >
        <fa-icon [icon]="faUserPlus" class="text-xl"></fa-icon>
      </a>
      <a
        class="flex h-11 flex-1 items-center justify-center rounded-xl text-gray-300 transition hover:text-primary"
        [routerLink]="['/ideas']"
        aria-label="Идеи пользователей"
      >
        <fa-icon [icon]="faLightbulb" class="text-xl"></fa-icon>
      </a>
      <a
        class="flex h-11 flex-1 items-center justify-center rounded-xl text-gray-300 transition hover:text-primary"
        [routerLink]="['/news']"
        aria-label="Новости и обновления"
      >
        <fa-icon [icon]="faNewspaper" class="text-xl"></fa-icon>
      </a>
    </div>
  </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
  <!-- Header -->
  <div
    class="bg-gray-900 text-on-primary  relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden"
  >
    <!-- Navigation toggle button -->
    <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
      <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
    </button>
    <!-- Components -->
    <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
      <!--            <languages></languages>-->
      <!--      <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>-->
      <!--            <search [appearance]="'bar'"></search>-->
      <!--      <shortcuts></shortcuts>-->
      <!--            <messages></messages>-->
      <!--            <button-->
      <!--                class="lg:hidden"-->
      <!--                mat-icon-button-->
      <!--                (click)="quickChat.toggle()">-->
      <!--                <mat-icon [svgIcon]="'heroicons_outline:chat-alt-2'"></mat-icon>-->
      <!--            </button>-->
      <user></user>
      <notifications></notifications>
<!--       Кнопка выхода -->
        <div class="flex items-center">
          <button mat-flat-button color="warn"
                  class="flex items-center"
                  (click)="signOut()">
            <fa-icon [icon]="faPowerOff" class="mr-0 md:mr-2"></fa-icon>
            <!-- Скрываем текст "Выход" на мобильных -->
            <span class="hidden md:inline">Выход</span>
          </button>
        </div>
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-col flex-auto">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    <router-outlet *ngIf="true"></router-outlet>
  </div>

  <!-- Footer -->
<!--  <div-->
<!--    class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden"-->
<!--  >-->
<!--    <span class="font-medium text-secondary"-->
<!--      >smmof &copy; {{ currentYear }}</span-->
<!--    >-->
<!--  </div>-->
</div>

<!-- Quick chat -->
<!--<quick-chat #quickChat="quickChat"></quick-chat>-->
